import ehoIcon from './icon.png';
import ehoBadge from './black.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Product</h1>

        <div className="Product">
          <img src={ehoIcon} className="App-logo" alt="logo" />
          <h2>2024年の恵方</h2>
          <small>
            恵方を向くためのコンパスアプリです。<br />
          </small>
          <br />
          <br />
          <a
            href="https://apps.apple.com/us/app/2020%E5%B9%B4%E3%81%AE%E6%81%B5%E6%96%B9%E3%82%B3%E3%83%B3%E3%83%91%E3%82%B9/id1438399263?itsct=apps_box&amp;itscg=30200"
          >
            <img
              src={ehoBadge}
              alt="Download on the App Store"
            />
          </a>
        </div>
      </header>

      <footer className="App-footer">
        <div>
          <p><a href="https://ski-u.craft.me/aboutme" className="App-link">About me</a></p>
          <p>&copy; 2024 Yunosuke Sakai all rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
